import BulkUpload from "./BulkUpload";

export const BulkUploadUsersComponent = ({
  fileUploadState,
  setFileUploadState,
  isAddBulkUsersLoading,
}: {
  // biome-ignore lint/suspicious/noExplicitAny: complex state
  fileUploadState: any;
  // biome-ignore lint/suspicious/noExplicitAny: complex state
  setFileUploadState: any;
  isAddBulkUsersLoading: boolean;
}) => {
  return (
    <BulkUpload
      fileUploadState={fileUploadState}
      setFileUploadState={setFileUploadState}
      isLoading={isAddBulkUsersLoading}
      type="users"
    />
  );
};
